import React, { useState } from 'react'
import styled from 'styled-components'
import SheetTitle from './Title'
import Tip from './Tip'

export default function PlaceSheet ({ place, tips }) {
  const [activeIndex, setActiveIndex] = useState(0)

  console.log('text', place)
  const handlePlacePress = (index, place) => {
    setActiveIndex(index)
  }

  return (
    <Container>
      <SheetTitle text="Dirección" icon="map-marker"/>
      <Text>
        {place.Address}
      </Text>

      <SheetTitle text="Descripción" icon="map" style={{ marginTop: 12 }}/>
      <Text>
        {place.Description}
      </Text>

      {tips && <SheetTitle text="Conectividad :" icon="map-signs" style={{ marginTop: 22 }}/>}
      {tips && tips.map(tip => (
        <>
          {console.log('type', tip)}
          <Tip
            key={tip.UUID}
            text={tip.Text}
            type={tip.Type}
          />
        </>
       ))}
    
    </Container>
  )
}

const Container = styled.div`
  background-color: #FFF;
  max-height: 430px;
  margin: 12px 5px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  padding: 20px;
  overflow-y: scroll
`
const Text = styled.p`
  padding: 8px;
  margin-left: 12px;
`
